const directive = {
    bind: function(el, binding, vnode) {
        let handler = function(e) {
            e.target.value = directive.format(e.target.value);
            vnode.elm.dispatchEvent(new CustomEvent('input')); // added this
        };

        el.addEventListener('blur', handler);
    },
    format(value) {
        let timeArray = value.split(':');
        let time = {
            hours: timeArray[0] || 0,
            minutes: timeArray[1] || 0,
        };

        time.hours = Math.min(time.hours, 23);
        time.minutes = Math.min(time.minutes, 45);

        if (time.minutes % 15 > 0) {
            if (time.minutes % 15 >= 8) {
                time.minutes += 15 - (time.minutes % 15);
            } else {
                time.minutes -= time.minutes % 15;
            }
        }

        let newTime = `${time.hours < 10 ? '0' + time.hours : time.hours}:${
            time.minutes < 10 ? '0' + time.minutes : time.minutes
        }`;

        return newTime;
    },
};

export default directive;
